<template>
  <b-modal ref="modal" centered class="text-left">
    <div slot="modal-title">
      Manage portfolios
    </div>
    <alert ref="alert" />
    <b-row>
      <b-col cols="7">
        <b-form-group label="Portfolio Name" label-for="pName" class="text-left">
          <b-form-input v-model="newPortfolioName" id="pName" required></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols ="5">
        <b-form-group label="Portfolio Type" label-for="pType" class="text-left">
          <b-form-select v-model="newPortfolioType" id="pType" required>
            <option value="Reinsurance">Reinsurance</option>
            <option value="Bonds">Bonds</option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="mb-2 mt-2">
      <b-col class="text-right">
        <b-btn variant="info" @click="createPortfolio" :disabled="newPortfolioName.length == 0">Create</b-btn>
      </b-col>
    </b-row>
    <b-row class="mb-2">
      <b-col cols="8">
        <span>{{fileName}}</span>
      </b-col>
      <b-col cols="4" class="text-right">
        <label class="file-select">
          <div class="btn btn-info">
            <!-- Display the filename if a file has been selected. -->
            <span>Load from XLSX</span>
          </div>
          <input id="xlsx_select" type="file" @change="handleFileChange"/>
        </label>
      </b-col>
    </b-row>

    <b-form-group label="Delete portfolios">
      <b-form-checkbox
        v-for="(portfolio, index) of portfolios"
        v-model="portfoliosToDelete"
        :key="portfolio.Id"
        :value="index"
        name="flavour-3a"
      >
        {{ portfolio.Name }}
      </b-form-checkbox>
    </b-form-group>
    <b-row class="mb-2 mt-2">
      <b-col class="text-right">
        <b-btn variant="danger" @click="deletePortfolio" :disabled="portfoliosToDelete.length == 0">Delete</b-btn>
      </b-col>
    </b-row>
    <div slot="modal-footer" />
  </b-modal>
</template>

<script>
import * as XLSX from 'xlsx';
import Alert from '../Alert';

export default {
  props: {
    portfolios: Object,
    unsaved: Boolean
  },
  data() {
    return {
      newPortfolioName: '',
      newPortfolioType: 'Reinsurance',
      portfoliosToDelete: [],
      fileName: '',
      alert: {
        timestamp: 0,
        type: '',
        msg: ''
      }
    };
  },
  methods: {
    showModal() {
      this.$refs.modal.show();
    },
    hideModal() {
      this.$refs.modal.hide();
      this.newPortfolioName = '';
      this.newPortfolioType = 'Reinsurance';
      this.portfoliosToDelete = [];
    },
    createPortfolio() {
      if (this.portfolios[this.newPortfolioName] == undefined) {
        this.portfolios[this.newPortfolioName] = {
          Name: this.newPortfolioName,
          PortfolioType: this.newPortfolioType,
          PortfolioEntries: [],
          IsNew: true,
          IsEditable: true
        };
        this.$emit('addPortfolio', this.portfolios, this.newPortfolioName);
        this.hideModal();
      } else {
        this.$refs.alert.showAlert(
          'danger',
          'Portfolio named ' + this.newPortfolioName + ' already exists.'
        );
      }
    },
    deletePortfolio() {
      if (this.unsaved) {
        const alert = window.alert(
          'You have unsaved portfolios. Please save them or reload portfolios.'
        );
        this.hideModal();
        return;
      }

      const deleteConfirmed = window.confirm(
        'Do you want to delete following portfolios:\n' +
          this.portfoliosToDelete.map(index => this.portfolios[index].Name).join('\n')
      );
      if (deleteConfirmed) {
        this.$emit('deletePortfolio', this.portfoliosToDelete);
        this.hideModal();
      }
    },
    handleFileChange(e) {
      let file = e.target.files[0];

      const reader = new FileReader();
      reader.onload = e => {
        const bstr = e.target.result;
        try {
          const wb = XLSX.read(bstr, { type: 'binary' });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          const filteredData = data.filter(cells =>
            cells.some(cell => Boolean(String(cell).trim()))
          );
          this.$emit('loadPortfolio', filteredData);
        } catch (err) {
          this.$emit('error', err);
        } finally {
          this.hideModal();
        }
      };
      reader.readAsBinaryString(file);
    }
  },
  components: {
    Alert
  }
};
</script>

<style lang="scss" scoped>
.file-select {
  > .select-button {
    padding: 1rem;

    color: white;
    background-color: #2ea169;

    border-radius: 0.3rem;

    text-align: center;
    font-weight: bold;
  }
}

#xlsx_select {
  display: none;
}
</style>
